// extracted by mini-css-extract-plugin
module.exports = {"displayArea":"ViewFaculty_displayArea__3KsqB","heading":"ViewFaculty_heading__178NN","allFaculty":"ViewFaculty_allFaculty__1RN5q"};